// Shared look of the hero side cards (customer, service center): one icon per
// card (the WidgetBox title), two text levels (titleSmall entity name,
// bodySmall for everything else), sections separated by a hairline — no
// captions, no chips, so the two cards read as one calm family.

/** A divider-separated section below the entity name. */
export const heroSectionSx = { mt: '14px', pt: '12px', borderTop: '1px solid #eee' } as const;
